module.exports = __webpack_public_path__ + "img/espaces-verts.da16b7ea.jpg";